<ew-mat-dialog-custom
  urlHelp="https://help.edvisor.io/edwallet/request-payments">
  <ew-mat-stepper-custom
    [validations]="validations"
    [sendIn]="'penultimate'"
    (send)="send()">
    <!-- student -->
    <ew-mat-stepper-custom-step>
      <div class="text-center grid gap-4 max-w-2xl">
        <div class="mb-5 text-5xl font-bold">
          {{ 'createRequestMoney:studentTitle' | translate }}
        </div>
        <div class="">
          {{ 'createRequestMoney:studentSubtitle' | translate }}
        </div>

        <form class="grid gap-2" [formGroup]="student">
          <!-- language -->
          <div class="w-full grid grid-cols-1 gap-4">
            <!-- language -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:languageInput' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <mat-select [formControl]="language">
                <mat-option value="es">{{
                  'language.es' | translate
                }}</mat-option>
                <mat-option value="en">{{
                  'language.en' | translate
                }}</mat-option>
                <mat-option value="pt">{{
                  'language.pt' | translate
                }}</mat-option>
              </mat-select>
              <mat-error *ngIf="language.errors">
                {{ 'shared:isRequired' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- source, platformId, firstname, lastname, country, city -->
          <div class="w-full grid grid-cols-2 gap-4">
            <!-- source -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:studentInputSource' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <mat-select [formControl]="sellerPlatform">
                <!-- <mat-option value="EDWALLET">EDWALLET</mat-option> -->
                <mat-option value="EDCOMMERCE">EDCOMMERCE</mat-option>
                <mat-option value="EDVISOR">EDVISOR</mat-option>
              </mat-select>
              <mat-error *ngIf="sellerPlatform.errors">
                {{ 'shared:isRequired' | translate }}
              </mat-error>
            </mat-form-field>

            <!-- platformId -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:studentInputPlatformId' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input
                matInput
                required
                formControlName="platformId"
                name="platformId"
                placeholder="" />
              <mat-error *ngIf="student.controls['platformId'].errors">
                <span *ngIf="student.controls['platformId'].errors['required']">
                  {{ 'shared:isRequired' | translate }}
                </span>

                <span
                  *ngIf="student.controls['platformId'].errors['maxlength']">
                  {{
                    student.controls['platformId'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>
              </mat-error>
            </mat-form-field>

            <!-- firstname -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:studentInputName' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input
                matInput
                required
                formControlName="firstname"
                name="firstname"
                placeholder="" />
              <mat-error *ngIf="student.controls['firstname'].errors">
                <span *ngIf="student.controls['firstname'].errors['required']">
                  {{ 'shared:isRequired' | translate }}
                </span>

                <span *ngIf="student.controls['firstname'].errors['maxlength']">
                  {{
                    student.controls['firstname'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>
              </mat-error>
            </mat-form-field>

            <!-- lastname -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:studentInputSurname' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input
                matInput
                required
                formControlName="lastname"
                name="lastname"
                placeholder="" />
              <mat-error *ngIf="student.controls['lastname'].errors">
                <span *ngIf="student.controls['lastname'].errors['required']">
                  {{ 'shared:isRequired' | translate }}
                </span>

                <span *ngIf="student.controls['lastname'].errors['maxlength']">
                  {{
                    student.controls['lastname'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>
              </mat-error>
            </mat-form-field>

            <!-- country -->
            <ew-select-country
              [width]="'100%'"
              [label]="'createRequestMoney:studentInputCountry'"
              (valueChanged)="
                student.patchValue({ country: $event.iso })
              "></ew-select-country>

            <!-- city -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:studentInputCity' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input
                matInput
                required
                formControlName="city"
                name="city"
                placeholder="" />
              <mat-error *ngIf="student.controls['city'].errors">
                <span *ngIf="student.controls['city'].errors['required']">
                  {{ 'shared:isRequired' | translate }}
                </span>

                <span *ngIf="student.controls['city'].errors['maxlength']">
                  {{
                    student.controls['city'].errors['maxlength'] | errorMaxValue
                  }}
                </span>
              </mat-error>
            </mat-form-field>
          </div>

          <!-- address -->
          <div class="w-full grid grid-cols-1 gap-4">
            <!-- address -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:studentInputAddress' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input
                matInput
                required
                formControlName="address"
                name="address"
                placeholder="" />
              <mat-error *ngIf="student.controls['address'].errors">
                <span *ngIf="student.controls['address'].errors['required']">
                  {{ 'shared:isRequired' | translate }}
                </span>

                <span *ngIf="student.controls['address'].errors['maxlength']">
                  {{
                    student.controls['address'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>
              </mat-error>
            </mat-form-field>
          </div>

          <!-- postalCode, dateOfBirth, email, phoneNumber-->
          <div class="w-full grid grid-cols-2 gap-4">
            <!-- postalCode -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:studentInputPostalCode' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input
                matInput
                required
                formControlName="postalCode"
                name="postalCode"
                placeholder="" />
              <mat-error *ngIf="student.controls['postalCode'].errors">
                <span *ngIf="student.controls['postalCode'].errors['required']">
                  {{ 'shared:isRequired' | translate }}
                </span>

                <span
                  *ngIf="student.controls['postalCode'].errors['maxlength']">
                  {{
                    student.controls['postalCode'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>
              </mat-error>
            </mat-form-field>

            <!-- dateOfBirth -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:studentInputBirthday' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                formControlName="dateOfBirth"
                (click)="picker.open()"
                required />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker
                #picker
                color="primary"
                startView="multi-year"
                [startAt]="startDate"></mat-datepicker>
              <mat-error *ngIf="student.controls['dateOfBirth'].errors">
                {{ 'shared:isRequired' | translate }}
              </mat-error>
            </mat-form-field>

            <!-- email -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:studentInputEmail' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input
                matInput
                required
                formControlName="email"
                name="email"
                placeholder="" />
              <mat-error *ngIf="student.controls['email'].errors">
                <span *ngIf="student.controls['email'].errors['required']">
                  {{ 'shared:isRequired' | translate }}
                </span>
                <span *ngIf="student.controls['email'].errors['email']">
                  {{ 'shared:formatEmail' | translate }}
                </span>

                <span *ngIf="student.controls['email'].errors['maxlength']">
                  {{
                    student.controls['email'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>
              </mat-error>
            </mat-form-field>

            <!-- phoneNumber -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:studentInputPhoneNumber' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input
                matInput
                required
                formControlName="phoneNumber"
                name="phoneNumber"
                placeholder="" />
              <mat-error *ngIf="student.controls['phoneNumber'].errors">
                <span
                  *ngIf="student.controls['phoneNumber'].errors['required']">
                  {{ 'shared:isRequired' | translate }}
                </span>

                <span
                  *ngIf="student.controls['phoneNumber'].errors['minlength']">
                  {{
                    student.controls['phoneNumber'].errors['minlength']
                      | errorMinValue
                  }}
                </span>

                <span
                  *ngIf="student.controls['phoneNumber'].errors['maxlength']">
                  {{
                    student.controls['phoneNumber'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>

                <span *ngIf="student.controls['phoneNumber'].errors['pattern']">
                  {{ 'shared:formatIncorrect' | translate }}
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </form>

        <form class="grid gap-2" [formGroup]="order">
          <!-- providerName, orderId -->
          <div class="w-full grid grid-cols-2 gap-4">
            <!-- providerName -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:orderInputProviderName' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input
                matInput
                required
                formControlName="providerName"
                name="providerName"
                placeholder="" />
              <mat-error *ngIf="order.controls['providerName'].errors">
                <span *ngIf="order.controls['providerName'].errors['required']">
                  {{ 'shared:isRequired' | translate }}
                </span>

                <span
                  *ngIf="order.controls['providerName'].errors['maxlength']">
                  {{
                    order.controls['providerName'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>
              </mat-error>
            </mat-form-field>

            <!-- orderId -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'createRequestMoney:orderInputOrderId' | translate }}
                <small class="text-gray-400">
                  ({{ 'shared:required' | translate }})
                </small>
              </mat-label>
              <input
                matInput
                required
                formControlName="orderId"
                name="orderId"
                placeholder="" />
              <mat-error *ngIf="order.controls['orderId'].errors">
                <span *ngIf="order.controls['orderId'].errors['required']">
                  {{ 'shared:isRequired' | translate }}
                </span>

                <span *ngIf="order.controls['orderId'].errors['maxlength']">
                  {{
                    order.controls['orderId'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </form>
      </div>
    </ew-mat-stepper-custom-step>

    <!-- payment -->
    <ew-mat-stepper-custom-step>
      <div class="text-center grid gap-4 max-w-2xl">
        <div class="mb-5 text-5xl font-bold">
          {{ 'createRequestMoney:paymentTitle' | translate }}
        </div>
        <div class="">
          {{ 'createRequestMoney:paymentSubtitle' | translate }}
        </div>

        <div class="w-full flex items-center mt-6 text-left">
          <div class="w-full">
            <div class="w-2/3 m-auto">
              <ew-select-currency
                class="[&>*]:!w-2/3"
                [label]="'createRequestMoney:paymentSelectCurrency'"
                [value]="payment.value.currency"
                (valueChanged)="
                  payment.patchValue({
                    currency: $event.currencyIso,
                    currencyAccountId: $event.companyCurrencyAccountId
                  })
                "></ew-select-currency>
            </div>

            <ew-price-information
              [currency]="payment.value.currency"
              [price]="0"
              (valueChanged)="
                payment.patchValue({ amount: $event })
              "></ew-price-information>
            <!-- <div class="text-center p-5">
                  <div class="">Wallet balance:</div>
                  <div class="text-warn font-medium text-lg">$5,200 CAD</div>
                </div> -->

            <div class="w-2/3 mx-auto mt-10">
              <ew-split-payment
                *ngIf="showSplitPaymentFeatureFlag"
                (toggleSplitPaymentEvent)="
                  payment.patchValue({ paymentType: $event })
                "></ew-split-payment>
            </div>
          </div>
        </div>
      </div>
    </ew-mat-stepper-custom-step>

    <!-- Split playment form -->
    <ew-mat-stepper-custom-step [hide]="!isSplitPayment">
      <ew-split-payment-form
        [currencyAccountId]="payment.value.currencyAccountId"
        [budget]="payment.value.amount"
        [currency]="payment.value.currency"
        (splitFormOutput)="setSplitForm($event)"></ew-split-payment-form>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step [hide]="!isSplitPayment">
      <ew-split-payment-summary
        [currency]="payment.value.currency"
        [budget]="payment.value.amount"
        [splits]="splits?.value"></ew-split-payment-summary>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step [hide]="!isSplitPayment">
      <ew-split-payment-summary
        [currency]="payment.value.currency"
        [budget]="payment.value.amount"
        [splits]="splits?.value"></ew-split-payment-summary>
    </ew-mat-stepper-custom-step>

    <!-- success message -->
    <ew-mat-stepper-custom-step>
      <div class="text-center grid gap-4 max-w-2xl">
        <div class="mb-5 text-5xl font-bold">
          {{ 'createRequestMoney:successTitle' | translate }}
        </div>
        <div class="">
          {{ 'createRequestMoney:successSubtitle' | translate }}
        </div>

        <mat-progress-spinner
          class="m-auto mt-5"
          [diameter]="24"
          [mode]="'indeterminate'"
          *ngIf="loading"></mat-progress-spinner>

        <div class="m-auto w-full grid gap-4" *ngIf="!loading">
          <div class="flex w-full mt-6">
            <img
              class="w-10 m-auto"
              width="150"
              src="assets/circle-check.svg"
              alt="" />
          </div>

          <div class="py-3 bg-gray-100">
            {{ paymentLinkBaseUrl }}
          </div>

          <button
            class="rounded-lg xs:w-full w-40"
            style="margin: auto"
            mat-stroked-button
            color="primary"
            (cdkCopyToClipboardCopied)="copied()"
            [cdkCopyToClipboard]="paymentLinkBaseUrl">
            <i class="fa-regular fa-link mr-2"></i>
            {{ 'createRequestMoney:successButton' | translate }}
          </button>
        </div>
      </div>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
